import { isResource } from '@medplum/core'
import type {
  Basic,
  Organization,
  Practitioner,
  Reference,
} from '@medplum/fhirtypes'
import { codeableConcept, hasCodeableConcept } from '#src/codeableConcept.ts'
import { BASIC_CODE_SYSTEM } from '#src/codeSystems.ts'
import { Label } from '#src/models/label.ts'
import type { QueryTypes } from '#src/search.ts'
import { isOfType } from '#src/utils.ts'

export class ParticipantLabel extends Label {
  static isInstance(value: unknown): value is Basic {
    return (
      isResource(value) &&
      isOfType(value, 'Basic') &&
      hasCodeableConcept(value.code, codeableConcept(ParticipantLabel.code))
    )
  }

  constructor({
    name,
    color,
    author,
  }: {
    name: string
    color: string
    author: Reference<Practitioner | Organization>
  }) {
    super({
      code: codeableConcept(ParticipantLabel.code),
      name,
      color,
      author,
    })
  }

  static isValidReferenceString(
    referenceString: unknown
  ): referenceString is ParticipantLabel['referenceString'] {
    return (
      typeof referenceString === 'string' &&
      referenceString.startsWith('Basic/')
    )
  }

  /**
   * Base FHIR search query for this resource — extended/modified at call sites.
   * Changing this affects every caller. Grep `baseSearchQuery` for impact before editing.
   */
  static baseSearchQuery(): QueryTypes {
    return {
      code: ParticipantLabel.code,
      _tag: Label.status.active,
      _sort: '-_lastUpdated',
      _count: '1000',
    }
  }

  static code = {
    system: BASIC_CODE_SYSTEM,
    code: 'participant-label',
    display: 'Participant Label',
  }
}
